import {useState} from "react";
import {BuildingTypeFormPopup} from "../form/BuildingTypeFormPopup";
import {BuildingTypeTable} from "../table/BuildingTypeTable";

import {Button} from '@komune-io/g2-components'
import {useTranslation} from "react-i18next";
import {Row} from "@komune-io/g2-layout";
import {
  BuildingType,
  BuildingTypeCreateCommand,
  BuildingTypeDeleteCommand,
  BuildingTypeUpdateCommand
} from "../../model/BuildingType";
import {
  useBuildingTypeAllQuery,
  useBuildingTypeCreateMutation, useBuildingTypeDeleteMutation,
  useBuildingTypeUpdateMutation
} from "../../api/BuildingTypeApi";
import {PlatformSubSection} from "@tracabois/template";

interface BuildingTypeSectionProps {
  title: string
}

export const BuildingTypeSection = (props: BuildingTypeSectionProps) => {
  const {title} = props
  const [selectedItem, setSelectedItem] = useState<Partial<BuildingType> | undefined>(undefined)
  const {t} = useTranslation()
  const buildingTypePageQuery = useBuildingTypeAllQuery();
  const [createBuildingType] = useBuildingTypeCreateMutation()
  const [updateBuildingType] = useBuildingTypeUpdateMutation()
  const [deleteBuildingType] = useBuildingTypeDeleteMutation()

  const closePopup = () => {
    setSelectedItem(undefined)
  }

  const handleCreate = async (item: BuildingTypeCreateCommand) => {
    await createBuildingType(item)
    closePopup()
    buildingTypePageQuery.refetch()
    return true
  }
  const handleUpdate = async (item: BuildingTypeUpdateCommand) => {
    await updateBuildingType(item)
    closePopup()
    buildingTypePageQuery.refetch()
    return true
  }
  const handleDelete = async (item: BuildingTypeDeleteCommand) => {
    await deleteBuildingType(item)
    closePopup()
    buildingTypePageQuery.refetch()
    return true
  }
  const clickHandler = (row: Row<BuildingType>) => {
    setSelectedItem(row.original)
  }
  const actions = (<Button color="primary"
                           onClick={() => setSelectedItem({})}>{t("buildingType.action.create", "Ajouter un type")}</Button>)
  return (
    <PlatformSubSection title={title}>
      <BuildingTypeTable page={buildingTypePageQuery.data}
                        onPageQueryChange={buildingTypePageQuery.setPageQuery}
                        onRowClicked={clickHandler}
                        isLoading={buildingTypePageQuery.isLoading}
                        actions={actions}
      />
      <BuildingTypeFormPopup
        open={!!selectedItem} item={selectedItem || {}}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        onCancel={closePopup}
      />
    </PlatformSubSection>
  )
}
